import { Card, CardGroup } from '@ps/isp-web-component-library';
import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import withWidgetTestId from '@swf/core/hoc/withWidgetTestId';
import type { WidgetFC } from '@swf/core/types/Widget';
import { IconLink, Menu } from '@swf/sports/components';
import useUrlMenuItems from '@swf/sports/hooks/useUrlMenuItems';

import { TXTWCL_Featured } from './SportsFeaturedWidget.messages.json';
import styles from './SportsFeaturedWidget.scss';
import SkeletonFeaturedWidget from './components/LoadingState/LoadingState';
import { sportsFeaturedWidgetModel, useSportsFeaturedWidget } from './model';

const SportsFeaturedWidget: WidgetFC = () => {
  const { widgetSelect } = useSportsFeaturedWidget();
  const menuItems = useSelector(widgetSelect.menuItems);
  const isLoading = useSelector(widgetSelect.isLoading);
  const errorCode = useSelector(widgetSelect.errorCode);
  const preloaded = useSelector(widgetSelect.hasPreloaded);

  const urlMenuItems = useUrlMenuItems(menuItems);

  if (isLoading && !preloaded) {
    return (
      <CardGroup hasFlushOnMobile className={styles.wrapper}>
        <Card>
          <SkeletonFeaturedWidget />
        </Card>
      </CardGroup>
    );
  }

  if (errorCode || !urlMenuItems.length) {
    return null;
  }
  return (
    <CardGroup hasFlushOnMobile className={styles.wrapper}>
      <Card>
        <header className={styles.header}>{<Translation {...TXTWCL_Featured} />}</header>
        <Menu>
          {urlMenuItems.map((item) => (
            <IconLink key={item.text} {...item} />
          ))}
        </Menu>
      </Card>
    </CardGroup>
  );
};

SportsFeaturedWidget.model = sportsFeaturedWidgetModel;

export default withWidgetTestId(SportsFeaturedWidget, 'sports-featured-menu');
